// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroSection_wrapper__S-tDc","heroImageWrapper":"HeroSection_heroImageWrapper__OiaxI","banner":"HeroSection_banner__40dp3"};